import ExpandableCollege from "./ExpandableCollege";
export default ExpandableCollege;
